import React from "react";

import Colors from "../../constants/Colors";
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import Icon from "components/Icon";


import {ItemContainer, ColStyled, Ball, Label1} from './styles';

const ListDetails = ({ value, navigation }) => (
  <ItemContainer>
    <Row>
      <Col md={2} sm={12} xm={12}>
        <Label1>{value.idOperation}</Label1>
      </Col>
      <Col md={2}>
        <Label1>
          {new Date(value.operationDate).toLocaleDateString("en-GB")}
        </Label1>
      </Col>
      <Col md={2}>
        <Label1>{value.productName}</Label1>
      </Col>
      <Col md={2}>
        <Label1>{value.personLastNameInsured ? value.personLastNameInsured : value.personLastName}</Label1>
      </Col>
      <Col md={2}>
        <Label1>{value.statusDescription}</Label1>
      </Col>
      <Col md={1}>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Ball
            color={
              value.sla > 7
                ? Colors.RED
                : value.sla > 5
                ? Colors.SECONDARY1
                : Colors.GREEN_LIGHT
            }
          />
          <Label1 style={{ marginBottom: 0, marginLeft: 5 }}>
            {value.sla > 9 ? value.sla : `0${value.sla}`}/07
          </Label1>
        </div>
      </Col>
      <Col md={1}>
        <ColStyled>
          <Icon
            name="edit"
            //onClick={() => history.push(`/quotes/info/${value.idProduct}`, { idOperation: value.idOperation })}
            onClick={() => navigation(value)}
            style={{ alignSelf: "center", cursor: "pointer" }}
          />
          <Icon
            name="duplicate-gray"
            onClick={() => {}}
            style={{
              alignSelf: "center",
              cursor: "pointer",
              marginLeft: 5,
              marginRight: 5,
            }}
          />
          <Icon
            name="folder-gray"
            onClick={() => navigation({...value, idDomainStatus: 6})}
            style={{ alignSelf: "center", cursor: "pointer" }}
          />
        </ColStyled>
      </Col>
    </Row>
    <hr></hr>
  </ItemContainer>
);

export default ListDetails;
